"use strict";

import React from 'react';
import AccountAddressForm from "./AccountAddressForm";
import SaveCancelButtons from "../../component/SaveCancelButtons";
import Icon from "../../component/Icon";

const AccountAddressFormBundle = ({address={}, type='billing', showAddressName=false,
                                  showAddressLocationType=true, saveText='Save',
                                  cancelText='Reset', onCancel=()=>{}, showCloseButton=true,
                                  onSubmit=()=>{},}) => {

    return (
        <div>
            {showCloseButton &&
                <a href="#" title="" className="btn__delete btn__delete--medium"
                   style={{display: 'block',marginLeft: 'auto',marginRight: '0',}}
                   onClick={onCancel} />
            }
            <AccountAddressForm onSubmit={onSubmit} data={address} type={type}
                                showAddressName={showAddressName}
                                showAddressLocationType={showAddressLocationType} >
                <SaveCancelButtons wrapperStyle={{paddingTop: 0,}}
                                   visible={true}
                                   cancelText="Reset"
                                   saveText={saveText}
                                   saveButtonType="submit"
                                   saveContent={<Icon name="right" className="icon--collapse-right" />}
                                   saveClassName=" has-icon-right" />
            </AccountAddressForm>
        </div>
    );
};

export default AccountAddressFormBundle;
